<template>
  <section class="sections sections--parallax sections--parallax__g">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="6">
          <div class="sections-box">
            <div class="sections--border">
              <span class="sections--title">Games</span>
              <h2 class="sections--menu">Songket Games</h2>
            </div>
          </div>
          <div class="my-10">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit qui
              voluptate omnis ratione eligendi accusantium, nostrum quis cum
              distinctio libero ea? Odit corrupti quibusdam quod ut eius atque
              nobis corporis?
            </p>
          </div>
          <div>
            <v-btn text class="highlights--button">
              <span>Start Games</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="mx-auto games" max-width="500">
            <v-img
              class="white--text text-center align-center games--header"
              height="150px"
              src="../assets/img/GamesHeader.png"
            >
              <v-card-title class="justify-center mb-0 font-weight-bold">
                Leaderboard
              </v-card-title>
              <v-card-text>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Corrupti, eius.
              </v-card-text>
            </v-img>

            <v-card-text class="games--list">
              <v-container v-for="(item, i) in items" :key="i">
                <v-row align="center">
                  <v-col cols="2" class="text-center">
                    <v-icon class="games--list__color">
                      mdi-trophy-variant
                    </v-icon>
                  </v-col>
                  <v-col>
                    <v-card-text
                      class="white--text font-weight-bold subtitle-1"
                      v-text="item.text"
                    >
                    </v-card-text>
                  </v-col>
                  <v-col cols="3" sm="2" class="text-center">
                    <v-list-item-title class="white--text">
                      <span class="text-caption white--text"> Poin</span> <br />
                      <span class="font-weight-bold text-h6">
                        {{ item.poin }}
                      </span>
                    </v-list-item-title>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
              </v-container>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "TheGames",
  data() {
    return {
      items: [
        { text: "Rizki Arnosa", poin: 110 },
        { text: "Ahmad Rusadi Muslim", poin: 220 },
        { text: "Bariman Saputra", poin: 420 },
        { text: "Asep Awaludin", poin: 130 },
        { text: "Ghesa Ariaputra", poin: 210 }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
